
<template>

  <div class="ob-outer login-outer">

    <div class="ob-header">
      <div class="ob-img">
        <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/profile.png" />
      </div>
      <h3>{{clauses.login}}</h3>
      <a class="ob-back" @click="$emit('closeLogin')"><small>x</small></a>
    </div>

    <div class="ob-body login-body" v-for="form in forms" v-if="activeForm === form.form" v-on:keyup.enter="enterSubmit(form)">
      <h3>{{langTitle(form.title)}}</h3>
      <div class="ob-input-box" v-for="i in form.inputs">
        <input class="ob-input" :type="i.type" v-model="$store.state.auth[i.val]" v-if="i.type !== 'password'"/>
        <password-component v-else v-model="$store.state.auth[i.val]" :i="i"></password-component>
        <label class="ob-label">{{setLangLabel(i.label)}}</label>
      </div>
      <a class="forgot-pw" v-if="form.link" @click="activeForm = form.link">{{clauses.forgot}}</a>
      <a class="ob-btns">
        <a :class="assessBtnType(form)" @click="submitForm(form)" v-if="formFulfilled(form)">Submit</a>
      </a>
    </div>
  </div>

</template>

<script>

import Forms from '@/lib/authTemplate';

import Password from './Password';
import Lang from '@/lib/langTemplates/LoginTemplate';

export default {

  data(){
    return {
      activeForm: 'login',
      forms: Forms
    }
  },

  components: {
    'password-component': Password
  },

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    switchHide(){
      if (this.showPw) {
        this.showPw = false;
        this.hideUrl = 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/001-view.png';
      } else {
        this.showPw = true;
        this.hideUrl = 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/002-private.png';
      }
    },

    setLangLabel(l){
      switch (l) {
        case 'Email':
          return this.clauses.email;
        break;
        case 'Password':
          return this.clauses.pw;
        break;
        case 'New Password':
          return this.clauses.newPw;
        break;
        case 'Confirm Password':
          return this.clauses.confPw;
        break;
        case 'Confirmation Code':
          return this.clauses.confCode;
        break;
      }
    },

    langTitle(t){
      switch (t) {
        case 'Enter New Password':
          return this.clauses.enterNewPw;
        break;
        case 'Forgot Password':
          return this.clauses.forgot;
        break;
        case 'Confirm Password Change':
          return this.clauses.confPwChange;
        break;
      }
    },

    setModel(val){
      return this[val];
    },

    assessBtnType(form) {
      let btn;
      switch (form.form) {
        case 'login':
          btn = 'prim';
        break;
        case 'changeTemp':
          btn = 'prim';
        break;
        case 'forgot':
          btn = 'tre';
        break;
        case 'forcePw':
          btn = 'prim';
        break;
      }
      return `land-btn ob-btn ${btn}-btn`;
    },

    formFulfilled(form){
      const self = this;
      return form.inputs.every(i => this.$store.state.auth[i.val]);
    },

    enterSubmit(form){
      if (this.formFulfilled(form)) {
        this.submitForm(form)
      }
    },

    async submitForm(form){
      this.$store.dispatch('loadingOn');
      try {
        const self = this;
        let params = form.params.reduce((a, i) => {
          let param = switchParam(i);
          a[param] = this.$store.state.auth[i];
          return a;
        }, {});
        await this.$store.dispatch(form.dispatch, params);
        if (form.onSucceed.util === 'show') {
          self.activeForm = form.onSucceed.dest;
          self.$store.dispatch('loadingOff');
        } else {
          self.$store.dispatch(form.onSucceed.dest);
        }
      } catch(err) {
        console.log({ERROR: err});
        if (err.response.data === 'replace temporary password') {
          this.activeForm = 'changeTemp';
          this.$store.dispatch('loadingOff');
        } else {
          let errNotif = {
            type: 'err',
            title: form.onFail.title,
            body: 'The credentials you entered are invalid. Please ensure you have the correct email/password combination to successfully log into BreeziPro'
          }
          this.$store.dispatch('initNotif', errNotif);
          this.$store.dispatch('loadingOff');
        }
      }
      // setTimeout(() => {
      //   this.$store.dispatch('loadingOff');
      // }, 3000)
    }
  },

}

function switchParam(i){
  let param;
  switch (i) {
    case 'forgotEmail':
      param = 'email';
    break;
    case 'pw':
      param = 'password';
    break;
    case 'changeTempPw':
      param = 'newPassword'
    break;
    case 'confPw':
      param = 'password'
    break;
    case 'confCode':
      param = 'code';
    break;
    default:
      param = i;
  }
  return param;
}

</script>

<style>

.login-outer {
  height: 435px;
  justify-content: flex-start;
}

.login-body {
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pw-nest {
  width: 260px;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 8px;
}

.pw-input {
  width: 220px;
  margin-right: 5px;
}

.hide-show {
  width: 30px;
  height: 100%;
  background-color: rgb(0, 153, 191);
  margin-top: 2px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.hide-show:hover {
  background-color: #dce1ec;
}

.hide-show img {
  width: 80%;
}

.forgot-pw {
  color: #b0b9f6;
  margin: 20px;
  cursor: pointer;
}

.forgot-pw:hover {
  color: rgb(0, 153, 191);
}

.login-body p {
  width: 400px;
  max-width: 95%;
  text-align: left;
  border: 3px solid rgb(0, 153, 191);
  margin-bottom: 25px;
  padding: 5px;
  border-radius: 5px;
}

.ob-input-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-body h3 {
  color: rgb(0, 153, 191);
}

</style>



// WEBPACK FOOTER //
// src/components/landing/Login.vue